import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconCircleInfoComponent } from './icon-circle-info/icon-circle-info.component';
import { IconCircleAttentionComponent } from './icon-circle-attention/icon-circle-attention.component';
import { IconCircleTimesComponent } from './icon-circle-times/icon-circle-times.component';
import { IconCircleCheckComponent } from './icon-circle-check/icon-circle-check.component';
import { IconRefreshComponent } from './icon-refresh/icon-refresh.component';
import { IconDownloadComponent } from './icon-download/icon-download.component';
import { IconTimesComponent } from './icon-times/icon-times.component';
import { IconCircleQuestionComponent } from './icon-circle-question/icon-circle-question.component';
import { IconCogComponent } from './icon-cog/icon-cog.component';
import { IconSignOutComponent } from './icon-sign-out/icon-sign-out.component';
import { IconUsersComponent } from './icon-users/icon-users.component';
import { IconDollarComponent } from './icon-dollar/icon-dollar.component';
import { IconDatabaseComponent } from './icon-database/icon-database.component';
import { IconFileInvoiceComponent } from './icon-file-invoice/icon-file-invoice.component';
import { IconHouseUserComponent } from './icon-house-user/icon-house-user.component';
import { IconBoxOpenComponent } from './icon-box-open/icon-box-open.component';
import { IconProjectDiagramComponent } from './icon-project-diagram/icon-project-diagram.component';
import { IconCubeComponent } from './icon-cube/icon-cube.component';
import { IconGridComponent } from './icon-grid/icon-grid.component';
import { IconUploadComponent } from './icon-upload/icon-upload.component';
import { IconCalendarComponent } from './icon-calendar/icon-calendar.component';
import { IconTrashAltComponent } from './icon-trash-alt/icon-trash-alt.component';
import { IconAppleComponent } from './icon-apple/icon-apple.component';
import { IconAndroidComponent } from './icon-android/icon-android.component';
import { IconPlusComponent } from './icon-plus/icon-plus.component';
import { IconArrowComponent } from './icon-arrow/icon-arrow.component';
import { IconTrashComponent } from './icon-trash/icon-trash.component';
import { IconPenComponent } from './icon-pen/icon-pen.component';
import { IconSearchComponent } from './icon-search/icon-search.component';
import { IconCheckComponent } from './icon-check/icon-check.component';
import { IconEllipsisComponent } from './icon-ellipsis/icon-ellipsis.component';
import { IconSortComponent } from './icon-sort/icon-sort.component';



@NgModule({
  declarations: [
    IconCircleInfoComponent,
    IconCircleAttentionComponent,
    IconCircleTimesComponent,
    IconCircleCheckComponent,
    IconRefreshComponent,
    IconDownloadComponent,
    IconTimesComponent,
    IconCircleQuestionComponent,
    IconCogComponent,
    IconSignOutComponent,
    IconUsersComponent,
    IconDollarComponent,
    IconDatabaseComponent,
    IconFileInvoiceComponent,
    IconHouseUserComponent,
    IconBoxOpenComponent,
    IconProjectDiagramComponent,
    IconCubeComponent,
    IconGridComponent,
    IconUploadComponent,
    IconCalendarComponent,
    IconTrashAltComponent,
    IconAppleComponent,
    IconAndroidComponent,
    IconPlusComponent,
    IconArrowComponent,
    IconTrashComponent,
    IconPenComponent,
    IconSearchComponent,
    IconCheckComponent,
    IconEllipsisComponent,
    IconSortComponent
  ],
  exports: [
    IconCircleInfoComponent,
    IconCircleAttentionComponent,
    IconCircleTimesComponent,
    IconCircleCheckComponent,
    IconRefreshComponent,
    IconDownloadComponent,
    IconTimesComponent,
    IconCircleQuestionComponent,
    IconCogComponent,
    IconSignOutComponent,
    IconUsersComponent,
    IconDollarComponent,
    IconDatabaseComponent,
    IconFileInvoiceComponent,
    IconHouseUserComponent,
    IconBoxOpenComponent,
    IconProjectDiagramComponent,
    IconCubeComponent,
    IconGridComponent,
    IconUploadComponent,
    IconCalendarComponent,
    IconTrashAltComponent,
    IconAppleComponent,
    IconAndroidComponent,
    IconPlusComponent,
    IconArrowComponent,
    IconTrashComponent,
    IconPenComponent,
    IconSearchComponent,
    IconCheckComponent,
    IconEllipsisComponent,
    IconSortComponent
  ],
  imports: [
    CommonModule
  ],
})
export class IconsModule { }
